import { defineComponent as d, inject as r, computed as f, createBlock as m, openBlock as c, mergeProps as g, unref as v, withCtx as P, renderSlot as b } from "vue";
import { PageSidebarOpenKey as y, PageManagedSidebarKey as B } from "./Page.vue2.js";
import O from "../Button.vue2.js";
import { useOUIAProps as S } from "../../helpers/ouia.js";
const I = Symbol("SidebarOpenKey"), $ = /* @__PURE__ */ d({
  name: "PfPageToggleButton",
  __name: "PageToggleButton",
  props: {
    id: { default: "nav-toggle" },
    sidebarOpen: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["update:sidebar-open"],
  setup(p, { emit: s }) {
    const t = p, l = S({ id: t.ouiaId, safe: t.ouiaSafe }), u = s, o = r(y), e = r(B), n = f({
      get: () => e != null && e.value ? !!(o != null && o.value) : t.sidebarOpen,
      set(a) {
        e != null && e.value && o ? o.value = a : u("update:sidebar-open", a);
      }
    });
    return (a, i) => (c(), m(O, g(v(l), {
      id: a.id,
      variant: "plain",
      "aria-label": "Side navigation toggle",
      "aria-expanded": n.value ? "true" : "false",
      onClick: i[0] || (i[0] = (_) => n.value = !n.value)
    }), {
      default: P(() => [
        b(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "aria-expanded"]));
  }
});
export {
  I as SidebarOpenKey,
  $ as default
};
